import TypographyParagraph from '../typography/TypographyParagraph'

const Comment = ({
	metadata,
	asCountersign = false,
}: {
	metadata: any
	asCountersign?: boolean
}) => {
	return (
		<div className="flex flex-col">
			{metadata.properties.title && (
				<div
					className={`${asCountersign ? 'border-b border-textInactiveLight px-4 py-2 dark:border-textInactiveDark' : ''}`}
				>
					<TypographyParagraph
						size="medium"
						isBold={true}
						additionalClasses="mb-1 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{metadata.properties.title}
					</TypographyParagraph>
				</div>
			)}
			<div
				className={`${asCountersign ? 'border-b border-textInactiveLight px-4 py-2 dark:border-textInactiveDark' : ''}`}
			>
				<TypographyParagraph
					size="medium"
					additionalClasses="mb-4 text-textPrimaryLight dark:text-textPrimaryDark"
				>
					{metadata.properties.description}
				</TypographyParagraph>
			</div>
		</div>
	)
}

export default Comment
